import React from "react";
import LatLongFormat from "../../components/LatLongFormat";
import DecimalDegrees from "../../components/DecimalDegrees";
import DegreesDecimalMinutes from "../../components/DegreesDecimalMinutes";
import DegreesMinutesSeconds from "../../components/DegreesMinutesSeconds";

export default function EffortForm3(props) {
  // Regex allows digits, an optional single decimal point, and up to four digits after the decimal
  const regex = new RegExp(`^(-?)\\d+\\.\\d{5,}$`);

  if (props.currentStep !== 3) {
    return null;
  }

  const handleLatLongFormatChange = (event) => {
    event.preventDefault();
    const latLonFormatValue =
      "dataset" in event.target ? event.target.dataset.latLonFormat : event.target.value;

    props.updateState({
      ...props.currentState,
      lat_long_format: latLonFormatValue,
    });
  };

  const handleLatChange = (event) => {
    const { name, value } = event.target;
    const { lat_long_format } = props.currentState;
    const newLatitude = { ...props.currentState.latitude_or_loran1 }; // Create a copy to avoid direct state mutation

    switch (lat_long_format) {
      case "Decimal Degrees":
        if (value === "" || !regex.test(value)) {
          newLatitude.decimal_degrees = value;
        }
        break;
      case "Degrees Decimal Minutes":
        newLatitude.degrees_decimal_minutes[name] = value;
        break;
      case "Degrees Minutes Seconds":
        newLatitude.degrees_minutes_seconds[name] = value;
        break;
      default:
        break;
    }
    props.updateState({
      ...props.currentState,
      latitude_or_loran1: newLatitude,
    });
  };

  const handleLonChange = (event) => {
    const { name, value } = event.target;
    const { lat_long_format } = props.currentState;
    const newLongitude = { ...props.currentState.longitude_or_loran2 }; // Create a copy to avoid direct state mutation

    switch (lat_long_format) {
      case "Decimal Degrees":
        if (value === "" || !regex.test(value)) {
          newLongitude.decimal_degrees = value;
        }
        break;
      case "Degrees Decimal Minutes":
        newLongitude.degrees_decimal_minutes[name] = value;
        break;
      case "Degrees Minutes Seconds":
        newLongitude.degrees_minutes_seconds[name] = value;
        break;
      default:
        break;
    }
    props.updateState({
      ...props.currentState,
      longitude_or_loran2: newLongitude,
    });
  };

  const locationHandler = (event) => {
    event.preventDefault();
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    const success = (pos) => {
      let coord = pos.coords;
      let newState = {};
      let Latitude = props.currentState.latitude_or_loran1;
      Latitude.decimal_degrees = coord.latitude.toFixed(4);
      let Longitude = props.currentState.longitude_or_loran2;
      Longitude.decimal_degrees = coord.longitude.toFixed(4);
      newState = {
        lat_long_format: "Decimal Degrees",
        latitude_or_loran1: Latitude,
        longitude_or_loran2: Longitude,
      };
      props.updateState({ ...props.currentState, ...newState });
    };

    const error = (err) => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };

    navigator.geolocation.getCurrentPosition(success, error, options);
  };

  return (
    <div className="margAll10">
      <LatLongFormat
        handleChange={handleLatLongFormatChange}
        latLongFormats={props.latLongFormats}
        lat_long_format={props.lat_long_format}
        helpText={props.helpText}
        currentLocationHandler={locationHandler}
      />
      {props.lat_long_format === "Decimal Degrees" && (
        <DecimalDegrees
          handleLatChange={handleLatChange}
          handleLonChange={handleLonChange}
          lat_long_format={props.lat_long_format}
          latitude_or_loran1={props.latitude_or_loran1}
          longitude_or_loran2={props.longitude_or_loran2}
        />
      )}
      {props.lat_long_format === "Degrees Decimal Minutes" && (
        <DegreesDecimalMinutes
          handleLatChange={handleLatChange}
          handleLonChange={handleLonChange}
          lat_long_format={props.lat_long_format}
          latitude_or_loran1={props.latitude_or_loran1}
          longitude_or_loran2={props.longitude_or_loran2}
        />
      )}
      {props.lat_long_format === "Degrees Minutes Seconds" && (
        <DegreesMinutesSeconds
          handleLatChange={handleLatChange}
          handleLonChange={handleLonChange}
          lat_long_format={props.lat_long_format}
          latitude_or_loran1={props.latitude_or_loran1}
          longitude_or_loran2={props.longitude_or_loran2}
        />
      )}
    </div>
  );
}
